export default "__VITE_ASSET__DvOj5c4K__"